/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Dashboard_Bookings_RevenueInputs */

const en_admin_dashboard_bookings_revenue = /** @type {(inputs: Admin_Dashboard_Bookings_RevenueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bookings Revenue`)
};

const de_admin_dashboard_bookings_revenue = /** @type {(inputs: Admin_Dashboard_Bookings_RevenueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einnahmen aus Buchungen`)
};

const es_admin_dashboard_bookings_revenue = /** @type {(inputs: Admin_Dashboard_Bookings_RevenueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingresos por reservas`)
};

const fr_admin_dashboard_bookings_revenue = /** @type {(inputs: Admin_Dashboard_Bookings_RevenueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recettes des réservations`)
};

const it_admin_dashboard_bookings_revenue = /** @type {(inputs: Admin_Dashboard_Bookings_RevenueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrate da prenotazioni`)
};

const pt_br2_admin_dashboard_bookings_revenue = /** @type {(inputs: Admin_Dashboard_Bookings_RevenueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Receita de reservas`)
};

const pl_admin_dashboard_bookings_revenue = /** @type {(inputs: Admin_Dashboard_Bookings_RevenueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przychody z rezerwacji`)
};

const hu_admin_dashboard_bookings_revenue = /** @type {(inputs: Admin_Dashboard_Bookings_RevenueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Foglalási bevétel`)
};

const ro_admin_dashboard_bookings_revenue = /** @type {(inputs: Admin_Dashboard_Bookings_RevenueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Venituri din Rezervari`)
};

/**
* | output |
* | --- |
* | "Bookings Revenue" |
*
* @param {Admin_Dashboard_Bookings_RevenueInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_dashboard_bookings_revenue = /** @type {((inputs?: Admin_Dashboard_Bookings_RevenueInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Dashboard_Bookings_RevenueInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_dashboard_bookings_revenue(inputs)
	if (locale === "de") return de_admin_dashboard_bookings_revenue(inputs)
	if (locale === "es") return es_admin_dashboard_bookings_revenue(inputs)
	if (locale === "fr") return fr_admin_dashboard_bookings_revenue(inputs)
	if (locale === "it") return it_admin_dashboard_bookings_revenue(inputs)
	if (locale === "pt-BR") return pt_br2_admin_dashboard_bookings_revenue(inputs)
	if (locale === "pl") return pl_admin_dashboard_bookings_revenue(inputs)
	if (locale === "hu") return hu_admin_dashboard_bookings_revenue(inputs)
	return ro_admin_dashboard_bookings_revenue(inputs)
});
export { admin_dashboard_bookings_revenue as "admin.dashboard.bookings_revenue" }